<template>
  <div>
    <el-dialog
      @closed="$emit('close')"
      custom-class="d-dialog d-dialog-p0"
      :visible.sync="isShow"
      :close-on-click-modal="false"
      width="1200px"
    >
      <div class="d-top-title d-p24">
        <div class="main-title">费用明细</div>
        <div class="time-desc">
          更新时间: {{ detailRes.updateTime | stamp2StrM }}
        </div>
      </div>
      <div class="content-wrapper">
        <TopInfo
          :detail="detailRes"
          :chooseContainerType="chooseContainerType"
        ></TopInfo>
        <ChargeDetail :detail="detailRes"></ChargeDetail>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TopInfo from "./components/TopInfo.vue";
import ChargeDetail from "./components/ChargeDetail/index.vue";
export default {
  props: {
    chooseData: {
      type: Object,
      default: () => {},
    },
    chooseContainerType: {
      type: String,
      default: "",
    },
  },

  components: {
    TopInfo,
    ChargeDetail,
  },
  data() {
    return {
      isShow: true,
      saveLoading: false,
      detailRes: {},
    };
  },
  created() {},
  mounted() {
    this.initDataFromRealtimePriceComparison();
  },
  methods: {
    formatListPrice(list = []) {
      return list.map((item) => {
        if (this.$emp(item.price)) {
          return item;
        } else {
          let price = Number(item.price);
          if (isNaN(price)) {
            return item;
          } else {
            return {
              ...item,
              price,
            };
          }
        }
      });
    },
    async initDataFromRealtimePriceComparison() {
      try {
        let res = this.$clone(this.chooseData);
        console.log("detailAPI=========", res);
        this.detailRes = res || {};
        // 重命名
        this.detailRes = {
          ...this.detailRes,
          shippingLogo: this.detailRes.shippingUrl,
          updateTime: this.detailRes.refreshTime,
          etd: this.detailRes.departureTime
            ? Date.parse(this.detailRes.departureTime)
            : "",
          eta: this.detailRes.arrivalTime
            ? Date.parse(this.detailRes.arrivalTime)
            : "",

          portStartName: this.detailRes.polPortCd,
          portEndName: this.detailRes.podPortCd,
          transferFlag: this.detailRes.travelWay,
          voyage: this.detailRes.tripTime,
          // transferName: this.detailRes.,
          shipName: this.detailRes.shipName,
          voyageNum: this.detailRes.voyage,
          routeCode: this.detailRes.lineCode,
        };
        this.detailRes.chooseContainerType = this.chooseContainerType;
        if (this.chooseContainerType === "20GP") {
          this.detailRes.costDetail = this.detailRes.costDetail20GP;
          this.detailRes.detention = this.detailRes.detention20GP;
        } else if (this.chooseContainerType === "40GP") {
          this.detailRes.costDetail = this.detailRes.costDetail40GP;
          this.detailRes.detention = this.detailRes.detention40GP;
        } else if (this.chooseContainerType === "40HQ") {
          this.detailRes.costDetail = this.detailRes.costDetail40HQ;
          this.detailRes.detention = this.detailRes.detention40HQ;
        }
        if (this.detailRes.costDetail && this.detailRes.costDetail.length > 0) {
          this.detailRes.allParseList = this.detailRes.costDetail;
          let allList = this.detailRes.allParseList || [];
          allList = this.formatListPrice(allList);
          let chargeAllDetail = {
            oceanList: [],
            surchargeList: [],
            importSurchargeList: [],
            exportSurchargeList: [],
            otherList: [],
          };
          allList.forEach((item) => {
            if (item.costCategory === "海运费") {
              item.costDetail = "海运费";
              chargeAllDetail.oceanList.push(item);
            } else if (item.costCategory === "运费附加费") {
              chargeAllDetail.surchargeList.push(item);
            } else if (item.costCategory === "出口附加费") {
              chargeAllDetail.exportSurchargeList.push(item);
            } else if (item.costCategory === "进口附加费") {
              chargeAllDetail.importSurchargeList.push(item);
            } else {
              chargeAllDetail.otherList.push(item);
            }
          });
          this.detailRes.costDetailParseResult = chargeAllDetail;
        }
        if (this.detailRes.detention && this.detailRes.detention.length > 0) {
          this.detailRes.detentionParseResult = this.detailRes.detention || [];
          this.detailRes.detentionParseResult = this.formatListPrice(
            this.detailRes.detentionParseResult
          );
        }
        // 特殊处理
      } catch (e) {
        this.detailRes = {};
        console.error(e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.d-top-title {
  display: flex;
  align-items: center;
  .main-title {
  }
  .time-desc {
    font-size: 14px;
    font-weight: 500;
    color: #484851;
    margin-left: 8px;
  }
}
</style>
